/* @flow */

export default class AppUpdateMode {
	static READ_ONLY = 'READ_ONLY';
	static NONE = 'NONE';
	static ALL = 'ALL';
	static CUSTOM = 'CUSTOM';
}
